import type React from 'react'
import { Link } from 'react-router-dom'
import type { SidebarSubMenuItemWithMatch } from './sidebar-support'

export function MenuGlyph({
    icon: IconOrSrc,
    name,
    className,
    strokeWidth = 1.75,
}: {
    icon: string | React.ElementType<{ className?: string; strokeWidth?: number | string }>
    name: string
    className?: string
    strokeWidth?: number
}) {
    if (typeof IconOrSrc === 'string') {
        return <img src={IconOrSrc} className={className} alt={name} />
    }
    const Icon = IconOrSrc
    return <Icon className={className} strokeWidth={strokeWidth} />
}

export function ConnectedSubItems({
    subItems,
    pathname,
    subItemMatches,
    isCollapsed,
}: {
    subItems: SidebarSubMenuItemWithMatch[]
    pathname: string
    subItemMatches: (subItem: SidebarSubMenuItemWithMatch, pathname: string) => boolean
    isCollapsed: boolean
}) {
    return (
        <div className='relative pl-4 mt-1 ml-6'>
            <div className='pointer-events-none absolute left-1 top-0 bottom-0 border-l border-[#E4DEE5]' />
            <ul className='space-y-2'>
                {subItems.map((subItem, idx) => {
                    const linkMatches = subItemMatches(subItem, pathname)
                    const isFirstWithThisLink = subItems.findIndex(s => s.link === subItem.link) === idx
                    const isSubItemActive = linkMatches && isFirstWithThisLink
                    return (
                        <li key={`${subItem.name}-${idx}`} className='relative'>
                            <span
                                className={`absolute -left-[16px] top-2.5 h-2 w-2 rounded-full 
                                    ${isSubItemActive ? 'bg-[#63316B]' : 'bg-[#E4DEE5]'}`}
                            />
                            <Link
                                to={subItem.link}
                                className={`block text-sm rounded-lg transition-all duration-150 py-1 pl-2 pr-2
                                    ${isSubItemActive ? `bg-[#E4DEE5] text-[#481C4F] ${isCollapsed ? 'px-2' : ''}` : 'text-[#585858]'}`}
                            >
                                {subItem.name}
                            </Link>
                        </li>
                    )
                })}
            </ul>
        </div>
    )
}
